<template>
  <div class="addPhone" @click.stop="toCarList">
    <van-icon name="warning-o" size="16" />
    <span>{{ text }}</span>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  setup(props) {
    const store = useStore()
    const router = useRouter() //路由
    const state = reactive({
      name: 'AddPhone',
      text: '点此添加手机号，查看更多卡券 >'
    })
    let toCarList = item => {
      router.push({
        path: '/carList',
        query: { from: 'loyaltyList' }
      })
    }
    return {
      ...toRefs(state),
      toCarList
    }
  }
}
</script>
<style lang="scss" scoped>
.addPhone {
  padding-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(184, 161, 11);
  font-weight: 100;
  span {
    margin-left: 4px;
  }
}
</style>
